import React from "react";
import { Link } from "react-router-dom";
import { clearRoutingHistory } from "../../../middlewares/sysNavigation/SysNavigation";
import { useAdminContext } from "../../../context/admin/context/AdminContext";
import { FiUsers, FiMapPin, FiLogOut } from "react-icons/fi";
import { VscFileSubmodule } from "react-icons/vsc";
import { BsHouseDoor, BsPinMap } from "react-icons/bs";

let homeRoute = "/";
let regionRoute = "/region";
let countriesRoute = "/countries/dashboard";
let levelRoute = "/levels/dashboard";
let adminRoute = "/admin";
let userRoute = "/user";

const Item = ({ to, icon: Icon, label, onClick, danger = false }) => (
  <Link to={to} onClick={onClick} aria-label={label}>
    <span
      className={[
        "group inline-flex min-w-[64px] flex-col items-center justify-center rounded-xl px-3 py-1.5",
        "transition hover:bg-gray-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500",
        danger ? "text-red-700 hover:bg-red-50" : "text-gray-800",
      ].join(" ")}
    >
      <Icon
        className={[
          "h-6 w-6 transition-transform group-hover:-translate-y-0.5",
          danger ? "text-red-700" : "text-gray-700 group-hover:text-gray-900",
        ].join(" ")}
      />
      <span
        className={[
          "mt-1 text-[11px] font-semibold tracking-wide",
          danger ? "text-red-700" : "text-gray-700 group-hover:text-gray-900",
        ].join(" ")}
      >
        {label}
      </span>
    </span>
  </Link>
);

const BottomNavigation = () => {
  const { logOut } = useAdminContext();

  return (
    <nav
      role="navigation"
      aria-label="Bottom navigation"
      className={[
        "lg:hidden mt-1 h-[72px] w-full",
        "rounded-t-2xl border-t border-gray-200 bg-white/95",
        "backdrop-blur supports-[backdrop-filter]:bg-white/80",
        "shadow-[0_-8px_30px_rgba(0,0,0,0.08)]",
        "flex items-center justify-between px-2",
      ].join(" ")}
    >
      <Item to={homeRoute} icon={BsHouseDoor} label="Home" />

      <Item
        to={regionRoute}
        icon={FiMapPin}
        label="Regions"
        onClick={() => clearRoutingHistory()}
      />

      <Item
        to={countriesRoute}
        icon={BsPinMap}
        label="Countries"
        onClick={() => clearRoutingHistory()}
      />

      <Item
        to={levelRoute}
        icon={VscFileSubmodule}
        label="Levels"
        onClick={() => clearRoutingHistory()}
      />

      <Item to={adminRoute} icon={FiUsers} label="Admins" />

      <Item to={userRoute} icon={FiUsers} label="Users" />

      {/* Logout (kept as button-like link for consistent layout; logic unchanged) */}
      <button
        type="button"
        onClick={() => logOut()}
        aria-label="Logout"
        className="group inline-flex min-w-[64px] flex-col items-center justify-center rounded-xl px-3 py-1.5 text-red-700 transition hover:bg-red-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-rose-500"
      >
        <FiLogOut className="h-6 w-6 transition-transform group-hover:-translate-y-0.5" />
        <span className="mt-1 text-[11px] font-semibold tracking-wide">Logout</span>
      </button>
    </nav>
  );
};

export default BottomNavigation;
